import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import chunk from 'lodash/chunk';
import fragments from '../../utils/graphql/fragments';
import LoadingIndicator from '../../components/LoadingIndicator';
import GameLink from '../GameList/GameLink/index';
import './MobileGameListPage.css';

class MobileGameListPage extends Component {
  getGamePages() {
    if (!this.props.data.games || !this.props.data.games.games) {
      return [];
    }

    return chunk(this.props.data.games.games, 8);
  }

  render() {
    const { data } = this.props;
    const games = data && data.games && data.games.games;

    const classNames = [
      'game-list game-list-mobile',
      data.loading ? 'loading' : ''
    ].join(' ');

    return (
      <div className={classNames}>
        {data.loading ? (
          <LoadingIndicator />
        ) : data.error ? (
          <div className="alert alert-danger">{data.error.message}</div>
        ) : (
          games &&
          games.map((game, i) => (
            <div key={i} className="game-link-container">
              <GameLink key={i} game={game} isMobile={true} />
            </div>
          ))
        )}
      </div>
    );
  }
}

MobileGameListPage.propTypes = {
  onInteraction: PropTypes.func,
  data: PropTypes.shape({
    games: PropTypes.shape({
      games: PropTypes.arrayOf(PropTypes.object)
    }),
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.instanceOf(Error), PropTypes.bool])
  })
};

const QUERY_GET_GAMES = gql`
  query GetGames {
    games {
      games {
        ...Game
      }
    }
  }
  ${fragments.game}
`;

export default graphql(QUERY_GET_GAMES)(MobileGameListPage);



// WEBPACK FOOTER //
// ./src/containers/MobileGameListPage/index.js